/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Time from 'fierry/util/time';


export default class
{
  constructor (status, parent)
  {
    this.status = status;
    this.parent = parent;
  }


  getProgressPercentage (date)
  {
    return this.getEndDate() ?  (1 - this.getRemainingTime(date) / this.getTotalTime()) : 1;
  }


  getTotalTime ()
  {
    if (this.getStartDate() && this.getEndDate())
    {
      return this.getEndDate() - this.getStartDate();
    }

    return 0;
  }


  getRemainingTime (date)
  {
    if (this.getEndDate())
    {
      return this.getEndDate() - date;
    }

    if (this.getStartDate())
    {
      return date - this.getStartDate();
    }

    return 0;
  }


  getStartDate ()
  {
    return (this.status != null) ? this.status.date : null;
  }


  getEndDate ()
  {
    return (this.status != null && this.status.event != null) ? this.status.event.date : null;
  }


  getParent ()
  {
    return this.parent;
  }


  isTerminal ()
  {
    return this.status == null;
  }


  isCreate ()
  {
    return this.isType('create');
  }


  isUpgrade ()
  {
    return this.isType('upgrade');
  }


  isDefault ()
  {
    return this.isType('default');
  }


  isDisband ()
  {
    return this.isType('disband');
  }


  isSetup ()
  {
    return this.isType('setup');
  }


  isActive ()
  {
    return this.isType('active');
  }


  isCooldown ()
  {
    return this.isType('cooldown');
  }


  isType (type)
  {
    return !this.isTerminal() && this.status.type === type;
  }


};
